import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import RequestAQuote from "./sections/RequestAQuote";
import OurGlobalPresence from "./sections/OurGlobalPresence";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <RequestAQuote />
      <OurGlobalPresence />
      <Footer />
    </div>;
}